import { RuntimeConfigurationContext } from 'libs/contexts';
import { getOssUrl, buildDownloadUrl as bdu } from 'libs/utils';
import { useContext } from 'react';

export default function useUrl() {
  const rtCtx = useContext(RuntimeConfigurationContext);
  const ossProvider = rtCtx.find((item) => item.key === 'ossProvider')?.value ?? 'obs';
  const privateHost = rtCtx.find((config) => config.key === 'oss')?.value;
  const publicHost = rtCtx.find((config) => config.key === 'obs')?.value;
  const publicBucketName = rtCtx.find((config) => config.key === 'public-app-name')?.value;
  const legacyHost = rtCtx.find((config) => config.key === 'legacy-obs')?.value;
  const privateBucketName = rtCtx.find((config) => config.key === 'private-app-name')?.value;

  return {
    getPublicUrl(url) {
      const conf = {
        privateHost,
        publicHost,
        publicBucketName,
        legacyHost,
        ossProvider,
        privateBucketName,
      };
      // console.log('conf', conf);
      return getOssUrl(url, conf);
    },
    buildDownloadUrl(url, filename) {
      const conf = {
        privateHost,
        ossProvider,
        publicBucketName,
        privateBucketName,
      };
      return bdu(url, filename, conf);
    },
  };
}
